import React from 'react'

import PropTypes from 'prop-types'

import * as S from './styled'

const SectionContent = ({ className, children, ...props }) => (
  <S.SectionContentWrapper
    className={`${className} section-content`}
    {...props}
  >
    {children}
  </S.SectionContentWrapper>
)

SectionContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  marginTop: PropTypes.number,
  marginBottom: PropTypes.number
}

export default SectionContent
